import { styled } from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;
